import { ProductTechnologyType } from "./productTechnology";

const ERROR_SOURCES_MAPPING = {
    UNDEFINED: ["MMC"],
    ELECTRONICS: ["MMC"],
    LASER: ["MMC", "TruControl"],
    PUNCHING: ["MMC"],
    COMBINED: ["MMC", "TruControl"],
    BENDING: ["MMC"],
    SOFTWARE: [],
    CO2LASER: ["TruControl"],
    SOLIDSTATELASER: ["TruControl"],
    MARKINGLASER: ["TruControl"],
    AQUACUT: ["MMC"],
    TRUSHEAR: ["MMC"],
    AUTOMATION: ["MMC"],
    "2DLASERCUTTING": ["MMC", "TruControl"],
    "3DLASERCUTTING": ["MMC", "TruControl"],
    "3DPRINTING": ["AM_HMI", "AM_DESKTOP", "AM_TITP"],
    COOLER: ["MMC"],
    DIODELASER: ["TruControl"],
    DISKLASER: ["TruControl"],
    FIBERLASER: ["TruControl"],
    PULSEDLASER: ["TruControl"],
    WELDING: ["MMC", "TruControl"],
    SHORTPULSEDLASER: ["TruControl"],
    STORAGESYSTEM: ["MMC"],
    LASERTUBECUTTING: ["MMC", "TruControl"]
};
const FALLBACK_ERROR_SOURCES = ["MMC"];

export const getErrorSourcesForTechnology = (productTechnology: ProductTechnologyType): string[] => {
    return ERROR_SOURCES_MAPPING[productTechnology] || FALLBACK_ERROR_SOURCES;
};

const ERROR_SOURCE_PATTERN = {
    MMC: /^([0-9]+)([.][0-9]+)*$/,
    TruControl: /^[a-f|A-F|0-9]{4}( |.)?[a-f|A-F|0-9]{4}$/,
    AM_HMI: /^[0-9]*$/,
    AM_DESKTOP: /^[0-9]*$/,
    AM_TITP: /^[A-Z]{3-4}(-)[0-9]{5}$/
};

const UNKNOWN = "UNDEFINED";

export const getErrorSourceForErrorNumber = (errorNumber: string, technology: ProductTechnologyType): string => {
    const filteredErrorSources = getErrorSourcesForTechnology(technology).filter((errorSource) => {
        if (ERROR_SOURCE_PATTERN[errorSource].test(errorNumber)) {
            return errorSource;
        }
        return false;
    });
    if (filteredErrorSources.length === 0) {
        return UNKNOWN;
    }
    return filteredErrorSources[0];
};
